import { Input } from '../../../ui/Input';
import type { QuestionDefinition } from '../../../../types/checkin';

interface TextListQuestionProps {
  question: QuestionDefinition;
  value: string[] | undefined;
  onChange: (value: string[]) => void;
}

export function TextListQuestion({
  question,
  value = [],
  onChange,
}: TextListQuestionProps) {
  const itemCount = question.minItems || 3;

  // Ensure we always have an array with itemCount slots
  const items = [...value];
  while (items.length < itemCount) {
    items.push('');
  }

  const handleChange = (index: number, newValue: string) => {
    const updated = [...items];
    updated[index] = newValue;
    // Filter out empty strings before passing to onChange
    onChange(updated.filter(item => item.trim() !== ''));
  };

  return (
    <div className="space-y-3">
      {items.slice(0, itemCount).map((item, index) => (
        <div key={index} className="flex items-center gap-3">
          <span className="flex-shrink-0 w-8 h-8 rounded-full bg-accent-100 dark:bg-accent-900/30 flex items-center justify-center text-sm font-medium text-accent-700 dark:text-accent-300">
            {index + 1}
          </span>
          <Input
            value={item}
            onChange={(e) => handleChange(index, e.target.value)}
            placeholder={question.placeholder || `Item ${index + 1}...`}
            className="flex-1"
          />
        </div>
      ))}
    </div>
  );
}
